import React from 'react';
import { Check } from 'lucide-react';
import { tx } from '@/translations/translations';

export const StepIndicator = ({ language, currentStep }) => {
  const steps = [
    { key: 'cart', label: tx(language, 'Carrito', 'Cart', 'סל') },
    { key: 'data', label: tx(language, 'Datos', 'Details', 'פרטים') },
    { key: 'pay', label: tx(language, 'Pago', 'Payment', 'תשלום') },
  ];
  return (
    <div className="bg-slate-900/95 px-4 pb-4">
      <div className="flex items-center justify-between max-w-md mx-auto text-[11px]">
        {steps.map((step, idx) => {
          const isActive = currentStep >= idx;
          const isCurrent = currentStep === idx;
          return (
            <React.Fragment key={step.key}>
              <div className="flex items-center gap-1.5">
                <div className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold transition-all ${isActive ? 'bg-cyan-500 text-white' : 'bg-slate-700 text-slate-400'} ${isCurrent ? 'ring-2 ring-cyan-400/50' : ''}`}>
                  {isActive && !isCurrent ? <Check className="w-3 h-3" /> : idx + 1}
                </div>
                <span className={`font-medium uppercase tracking-wider ${isActive ? 'text-white' : 'text-slate-500'}`}>
                  {step.label}
                </span>
              </div>
              {idx < 2 && (
                <div className={`flex-1 h-px mx-2 ${isActive ? 'bg-cyan-500' : 'bg-slate-700'}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
